module.exports = __webpack_public_path__ + "static/fonts/poppins-v5-latin-800-99a9e7bac31ddfc2b58e0025f76c65d1.woff";